// extracted by mini-css-extract-plugin
module.exports = {"content":"_1rx5rycjVWCqQmls9gfRB5"};